import { Button, Typography } from '@mui/material'
import { ComponentProps } from 'react'
import { Colors } from '~/libs/mui/theme'

/**
 * ボーダーとテキストカラーが灰色のボタン
 */
export function GrayButton({ children, sx, ...props }: ComponentProps<typeof Button>): JSX.Element {
  return (
    <Button
      sx={{
        color: Colors.color5A5957,
        minHeight: 32,
        minWidth: 50,
        borderRadius: '4px',
        backgroundColor: 'transparent',
        border: `solid 1.5px ${Colors.color5A5957}`,
        cursor: 'pointer',
        ...sx,
      }}
      {...props}
    >
      <Typography fontWeight={500}>{children}</Typography>
    </Button>
  )
}
